export default __webpack_public_path__ + "static/media/award.d5a932bc.svg";